import { fmt, fmtA, fmtDate } from "../../utils/helper";

export const TxTable = ({ rows, side }) => {
  const isReceive = side === "receive";
  const accentBg = isReceive ? "#EAF3DE" : "#FAECE7";
  const accentTxt = isReceive ? "#27500A" : "#712B13";

  return (
    <div style={{ overflowX: "auto" }}>
      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
          fontSize: 13,
          tableLayout: "fixed",
        }}
      >
        <colgroup>
          <col style={{ width: "5%" }} />
          <col style={{ width: "10%" }} />
          <col style={{ width: "12%" }} />
          <col style={{ width: "30%" }} />
          <col style={{ width: "20%" }} />
          <col style={{ width: "23%" }} />
        </colgroup>
        <thead>
          <tr
            style={{
              borderBottom: "0.5px solid var(--color-border-secondary)",
            }}
          >
            {[
              "S#",
              "Serial",
              "Date",
              "Description",
              "Weight (g)",
              "Amount (PKR)",
            ].map((h, i) => (
              <th
                key={i}
                style={{
                  padding: "8px 10px",
                  textAlign: i >= 4 ? "right" : "left",
                  fontSize: 11,
                  fontWeight: 500,
                  color: "var(--color-text-secondary)",
                  letterSpacing: "0.03em",
                }}
              >
                {h}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row, i) => (
            <tr
              key={i}
              style={{
                borderBottom: "0.5px solid var(--color-border-tertiary)",
                background:
                  i % 2 === 0
                    ? "transparent"
                    : "var(--color-background-secondary)",
              }}
            >
              <td
                style={{
                  padding: "8px 10px",
                  color: "var(--color-text-tertiary)",
                  fontSize: 12,
                }}
              >
                {i + 1}
              </td>
              <td
                style={{
                  padding: "8px 10px",
                  fontWeight: 500,
                  color: "var(--color-text-primary)",
                }}
              >
                #{row.serialNo}
              </td>
              <td
                style={{
                  padding: "8px 10px",
                  color: "var(--color-text-secondary)",
                  fontSize: 12,
                }}
              >
                {fmtDate(row.date)}
              </td>
              <td style={{ padding: "8px 10px" }}>
                <span style={{ display: "flex", alignItems: "center", gap: 6 }}>
                  <span
                    style={{
                      fontSize: 10,
                      padding: "1px 7px",
                      borderRadius: 99,
                      fontWeight: 500,
                      background: row.isSilver ? "#E6F1FB" : accentBg,
                      color: row.isSilver ? "#0C447C" : accentTxt,
                    }}
                  >
                    {row.isSilver ? "silver" : "gold"}
                  </span>
                  <span style={{ color: "var(--color-text-primary)" }}>
                    {row.description}
                  </span>
                  {row.isRateWork && (
                    <span
                      style={{
                        fontSize: 10,
                        padding: "1px 7px",
                        borderRadius: 99,
                        background: "#EEEDFE",
                        color: "#3C3489",
                        fontWeight: 500,
                      }}
                    >
                      rate work
                    </span>
                  )}
                </span>
              </td>
              <td
                style={{
                  padding: "8px 10px",
                  textAlign: "right",
                  fontFamily: "monospace",
                  color:
                    row.weight === 0
                      ? "var(--color-text-tertiary)"
                      : "var(--color-text-primary)",
                }}
              >
                {row.weight > 0 ? fmt(row.weight) : "—"}
              </td>
              <td
                style={{
                  padding: "8px 10px",
                  textAlign: "right",
                  fontFamily: "monospace",
                  color:
                    row.amount === 0
                      ? "var(--color-text-tertiary)"
                      : "var(--color-text-primary)",
                }}
              >
                {row.amount > 0 ? fmtA(row.amount) : "—"}
              </td>
            </tr>
          ))}
        </tbody>
        <tfoot>
          <tr
            style={{
              borderTop: "0.5px solid var(--color-border-secondary)",
              background: "var(--color-background-secondary)",
            }}
          >
            <td
              colSpan={4}
              style={{
                padding: "8px 10px",
                fontSize: 12,
                fontWeight: 500,
                color: "var(--color-text-secondary)",
              }}
            >
              Totals
            </td>
            <td
              style={{
                padding: "8px 10px",
                textAlign: "right",
                fontFamily: "monospace",
                fontWeight: 500,
                color: "var(--color-text-primary)",
              }}
            >
              {fmt(rows.reduce((s, r) => s + (r.weight || 0), 0))} g
            </td>
            <td
              style={{
                padding: "8px 10px",
                textAlign: "right",
                fontFamily: "monospace",
                fontWeight: 500,
                color: "var(--color-text-primary)",
              }}
            >
              {fmtA(rows.reduce((s, r) => s + (r.amount || 0), 0))}
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
  );
};
